import { render, staticRenderFns } from "./TgbTags.vue?vue&type=template&id=4b1e2216"
import script from "./TgbTags.vue?vue&type=script&lang=js"
export * from "./TgbTags.vue?vue&type=script&lang=js"
import style0 from "./TgbTags.vue?vue&type=style&index=0&id=4b1e2216&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports